import { useAuth } from "../contexts/AuthContext";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";

export const useShare = () => {
  const { currentUser } = useAuth();
  const navigate = useNavigate();

  const handleShare = async (
    shareData: {
      title: string;
      text: string;
      url: string;
    },
    fallbackAction?: () => void
  ) => {
    // Check if user is authenticated
    if (!currentUser) {
      toast.error("Please sign up to share content and earn rewards!");
      // Redirect to signup page
      navigate("/signup");
      return false;
    }

    // Try to use Web Share API
    if (navigator.share) {
      try {
        await navigator.share(shareData);
        return true;
      } catch (error) {
        console.log("Error sharing:", error);
        return false;
      }
    } else {
      // Fallback for browsers that don't support Web Share API
      try {
        await navigator.clipboard.writeText(shareData.url);
        toast.success("Link copied to clipboard!");
        
        // Execute fallback action if provided
        if (fallbackAction) {
          fallbackAction();
        }
        
        return true;
      } catch (error) {
        console.log("Error copying to clipboard:", error);
        toast.error("Failed to copy to clipboard");
        return false;
      }
    }
  };

  const copyToClipboard = async (text: string, successMessage = "Copied to clipboard!") => {
    // Check if user is authenticated
    if (!currentUser) {
      toast.error("Please sign up to share content and earn rewards!");
      // Redirect to signup page
      navigate("/signup");
      return false;
    }

    try {
      await navigator.clipboard.writeText(text);
      toast.success(successMessage);
      return true;
    } catch (error) {
      console.log("Error copying to clipboard:", error);
      toast.error("Failed to copy to clipboard");
      return false;
    }
  };

  return {
    handleShare,
    copyToClipboard,
    isAuthenticated: !!currentUser,
  };
};
